module.exports = __webpack_public_path__ + "img/598.c1e4e2d6.jpg";